import React, { useState } from "react";
import { Form, Spinner } from "reactstrap";
import { Card } from "../../CommonElements/Hajj/Card";
import { Button, Stack } from "react-bootstrap";
import { Label } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { AntInput } from "../../CommonElements/AntInput";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  SquareLock01Icon,
  CheckmarkCircle01Icon,
} from "@hugeicons/core-free-icons";
import { Trans, useTranslation } from "react-i18next";
import { useConfirmOtpMutation } from "../../services/profile/profile";
import { Link } from "react-router";
import { OtpCountDown } from "../../Component/OtpCountDown/OtpCountDown";
import { toast } from "react-toastify";

export const Otp = ({
  email,
  changeEmailMutation,
  initialSeconds,
  updateExpiresAt,
}) => {
  const { t } = useTranslation();
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email,
      otp: "",
    },
  });

  const { mutate: confirmOtpMutation, isPending } = useConfirmOtpMutation(
    setError,
    setIsSuccess
  );

  const onSubmit = (data) => {
    confirmOtpMutation(data);
  };

  // Show success message if email change was successful
  if (isSuccess) {
    return (
      <Card className="pattern-card mx-auto" style={{ maxWidth: "36.3125rem" }}>
        <div className="text-center">
          <HugeiconsIcon
            size={64}
            icon={CheckmarkCircle01Icon}
            className="text-success mb-3"
          />
          <p className="H2 text-success mb-3">
            {t("EMAIL_CHANGED_SUCCESSFULLY")}
          </p>
          <p className="h5 text-secondary fw-bold mb-4">
            {t("EMAIL_CHANGE_SUCCESS_DESCRIPTION", { email })}
          </p>
          <Link className="btn btn-primary  w-100" to="/app/me">
            {t("CONTINUE")}
          </Link>
        </div>
      </Card>
    );
  }

  return (
    <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
      <Card className="pattern-card mx-auto" style={{ maxWidth: "36.3125rem" }}>
        <p className="H2">{t("ENTER_OTP_TITLE")}</p>
        <p className="h5 text-secondary fw-bold mb-4">
          <Trans
            i18nKey="ENTER_OTP_DESCRIPTION"
            values={{ email }}
            components={{
              span: <span className="text-brand fw-bold" />,
            }}
          />
        </p>

        <Stack gap={2} className="mb-4">
          <Label for="otp" className="required">
            {t("OTP_PASSWORD_LABEL")}
          </Label>
          <Controller
            control={control}
            name="otp"
            rules={{
              required: t("OTP_REQUIRED"),
            }}
            render={({ field }) => (
              <Stack gap={2}>
                <AntInput
                  id="otp"
                  type="otp"
                  placeholder={t("ENTER_OTP_HERE")}
                  {...field}
                  prefix={<HugeiconsIcon size={20} icon={SquareLock01Icon} />}
                />
                <OtpCountDown
                  initialSeconds={initialSeconds}
                  onComplete={() => { }}
                  renderOnFinish={
                    <div>
                      {t("OTP_NOT_RECEIVED")}
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          changeEmailMutation(
                            { email },
                            {
                              onSuccess: () => {
                                updateExpiresAt();
                              },
                            }
                          );
                        }}
                      >
                        <span className="text-brand fw-bold">
                          {t("RESEND_OTP")}
                        </span>
                      </Link>
                    </div>
                  }
                />
              </Stack>
            )}
          />

          {errors.otp && (
            <div className="text-danger small mt-1">{errors.otp.message}</div>
          )}
        </Stack>

        <Button
          disabled={isPending}
          type="submit"
          variant="primary"
          className="w-100"
        >
          {isPending ? (
            <>
              <Spinner animation="border" size="sm" />
              {t("CONFIRM_OTP_IN_PROGRESS")}
            </>
          ) : (
            t("CONFIRM_OTP")
          )}
        </Button>
      </Card>
    </Form>
  );
};
